import * as React from 'react';
import { useState, useRef, useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Card, Row, Col, FormGroup, Label, Input } from 'reactstrap';

import { ApplicationState } from '../../store';

import * as CartSearchStore from '../../store/CartSearch';
import * as OrderSearchStore from '../../store/OrderSearch';
import Loader from '../../components/shared/Loader';
import SeachCartCard from "./SeachCartCard";
import { Order } from '../../models/Order';
import CreateNewCartModal from '../ProductSearch/CreateNewCartModal';

function SearchCartPage(props: {
    cartSearchState: CartSearchStore.IState,
    cartSearchActions: typeof CartSearchStore.actionCreators,
    orderSearchStore: OrderSearchStore.IState,
    orderSearchActions: typeof OrderSearchStore.actionCreators
}) {
    const { cartSearchState, cartSearchActions, orderSearchStore, orderSearchActions } = props;

    const [cartId, setCartId] = useState("");
    const [email, setEmail] = useState("");
    const [cartName, setCartName] = useState("");
    const [openCreateCartDlg, setOpenCreateCartDlg] = useState(false);
    const [selectedCartIds, setSelectedCartIds] = useState([]);

    const loader = useRef(null);
    const observer = useRef(null);

    const cartSearchApend = () => {
        if (cartSearchState.postBack
            && !cartSearchState.loading
            && cartSearchState.totalCount > cartSearchState.items.length) {
            let page = cartSearchState.pageIndex + 1;
            cartSearchActions.cartSearch(cartId, cartName, email, page, cartSearchState.pageSize, true);
        }
    }

    const cartSearch = () => {
        cartSearchActions.cartSearch(cartId, cartName, email, cartSearchState.pageIndex, cartSearchState.pageSize, false);
    };

    const cartSearchReset = () => {
        setCartId("");
        setEmail("");
        setCartName("");
        cartSearchActions.cartSearchReset();
    };

    const selectedCarts = (cartId: string) => {
        let ids = [...selectedCartIds];
        const index = ids.indexOf(cartId);
        if (index < 0) {
            ids.push(cartId);
        }
        else {
            ids = ids.filter(x => x !== cartId);
        }

        setSelectedCartIds(ids);
    }

    const lastDataElementRef = useCallback(node => {
        if (observer.current) {
            observer.current.disconnect();
        }

        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting) {
                cartSearchApend();
            }
        });

        if (node) {
            observer.current.observe(node);
        }
    }, [cartSearchState]);

    const reorder = (order: Order) => {
        console.log("orderId", order.Id);

        //setState({ reorderOrder: order });

        orderSearchActions.reorder(order.PartnerId, order.Id);
    }

    useEffect(() => {
        if (orderSearchStore.reorderCartId !== undefined) {
            document.location.assign(`/cart?id=${orderSearchStore.reorderCartId}`);
        }

    }, [orderSearchStore])

    return (<div className="py-4 container search-page">
        <Row>
            <Col>
                <h1>Search Active Carts</h1>
            </Col>
        </Row>
        <Row>
            <Col>
                <Card body className="mt-3 pb-2">
                    <Row className="cart-form">
                        <Col md={2} className="col-auto">
                            <FormGroup>
                                <Label for="txtCartId">
                                    Cart ID
                                </Label>
                                <Input
                                    id="txtCartId"
                                    name="cartId"
                                    placeholder="Cart ID"
                                    type="text"
                                    value={cartId}
                                    onChange={(e) => { setCartId(e.target.value); }}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={2} className="col-auto">
                            <FormGroup>
                                <Label for="txtCartName">
                                    Cart Name
                                </Label>
                                <Input
                                    id="txtCartName"
                                    name="cartName"
                                    placeholder="Cart Name"
                                    type="text"
                                    value={cartName}
                                    onChange={(e) => { setCartName(e.target.value); }}
                                />
                            </FormGroup>
                        </Col>
                        <Col md={2} className="col-auto">
                            <FormGroup>
                                <Label for="txtUserEmail">
                                    User Email
                                </Label>
                                <Input
                                    id="txtUserEmail"
                                    name="email"
                                    placeholder="User Email"
                                    type="email"
                                    value={email}
                                    onChange={(e) => { setEmail(e.target.value); }}
                                />
                            </FormGroup>
                        </Col>
                        <Col className="col-auto ml-auto ml-auto">
                            <div className="d-flex justify-content-end">
                                <div className="form-group">
                                    <label className="d-md-block d-sm-none">&nbsp;</label>
                                    <Button color="primary" className="rounded-0 px-4 text-uppercase" onClick={() => { cartSearch(); }}>Search Carts</Button>
                                </div>
                                <div className="form-group">
                                    <label className="d-md-block d-sm-none">&nbsp;</label>
                                    <Button color="clear" onClick={() => { cartSearchReset(); }}>Reset Search</Button>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>

        <Row className="py-4">
            <Col>
                {cartSearchState.totalCount > 0 &&
                    <div className="cart">
                        <Row className="align-items-baseline">
                            <Col>
                                <div className="cart-header my-4">
                                    <span>Total Carts: </span><b>{new Intl.NumberFormat('en-US').format(cartSearchState.totalCount)}</b>
                                </div>
                            </Col>
                            <Col>
                                {selectedCartIds.length > 1 &&
                                    <div className="d-flex justify-content-end my-4 col-delete-cart">
                                        {cartSearchState.mergingCarts && <Loader />}

                                        <Button color="link" aria-label="Merge Carts"
                                            className="ml-2"
                                            disabled={cartSearchState.mergingCarts}
                                            onClick={() => { setOpenCreateCartDlg(true); }}
                                        >Merge Carts</Button>
                                    </div>
                                }
                            </Col>
                        </Row>
                    </div>
                }
                {(cartSearchState.totalCount > 0
                    && cartSearchState.items && cartSearchState.items.length > 0) &&
                    <>{cartSearchState.items.map((cart) => (
                        <div className="shopping-cart-card-wrapper" key={cart.CartId}>
                            <SeachCartCard
                                cart={cart}
                                reorderInProgress={orderSearchStore.reorderInProgress}
                                reorder={reorder}
                                viewCart={() => document.location.assign("/cart?id=" + cart.CartId)}
                                selectedCardIds={selectedCarts}
                            />
                        </div>
                    ))}</>
                }
                <div ref={lastDataElementRef}></div>
                {!cartSearchState.loading && cartSearchState.totalCount == 0 &&
                    <div className="pb-2">
                        <p className="no-results-found">We can't find an active Cart ID</p>
                        {false && <p className="no-results-found">We have found a prior matching order</p>}
                        <Button
                            color="primary"
                            outline
                            className="rounded-0 px-4 py-2 text-uppercase"
                            onClick={() => { document.location.assign("order-search"); }}
                        >
                            Go To My Orders
                        </Button>
                    </div>}
                <div ref={loader}>{cartSearchState.loading && <Loader />}</div>
            </Col>
        </Row>

        <CreateNewCartModal open={openCreateCartDlg}
            onCancel={() => setOpenCreateCartDlg(false)}
            onAdd={(name) => {
                cartSearchActions.cartMerge(selectedCartIds, name, () => cartSearch());

                setSelectedCartIds([]);
                setOpenCreateCartDlg(false);
            }}
        />
    </div>)
}

export default connect((state: ApplicationState) => ({
    cartSearchState: state.cartSearch ? state.cartSearch : CartSearchStore.unloadedState,
    orderSearchStore: state.orderSearch ? state.orderSearch : OrderSearchStore.unloadedState
}),
    (dispatch, getState) => ({
        cartSearchActions: bindActionCreators(CartSearchStore.actionCreators, dispatch),
        orderSearchActions: bindActionCreators(OrderSearchStore.actionCreators, dispatch)
    }))(SearchCartPage);